export { default } from './adaptive-card';
